import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import renastic from "./assets/rentastic.png";

function Footer() {
  const navigate = useNavigate();

  const legalLinks = [
    { text: "Privacy Policy", route: "/privacypolicy" },
    { text: "Terms & Conditions", route: "/terms" },
    { text: "About Us", route: "/aboutus" }
  ];

  const contactInfo = [
    { text: "rentastictoys@gmail.com", href: "mailto:rentastictoys@gmail.com" }
  ];

  const socialLinks = [
    {
      name: "Facebook",
      href: "#",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      )
    },
    {
      name: "Twitter/X",
      href: "#",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
        </svg>
      )
    },
    {
      name: "Instagram",
      href: "#",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
        </svg>
      )
    },
    {
      name: "YouTube",
      href: "#",
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
      )
    }
  ];

  const handleLegalNavigation = (route) => {
    navigate(route);
  };

  return (
    <footer className="lg:mx-10 rounded-t-3xl px-10 pt-16 pb-10 text-white bg-[#002347] max-sm:px-4 max-sm:pt-10 max-sm:pb-6">
      <motion.div
        className="flex justify-between items-start mx-auto my-0 max-w-[1400px] max-md:flex-col max-md:gap-10"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <div className="flex-1 max-w-[400px]">
        <div className="flex items-center gap-3 mb-5 ">
           <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                <img
                src="https://cdn.acsdev.in/Rentastic/rentastic.png"
                alt="Rentastic Toys Logo"
                className="w-12 h-12 object-contain"
                />
            </div>
            <h2 className="text-2xl font-bold">Rentastic Toys</h2>
        </div>
        <p className="mb-6 text-sm leading-5 text-white text-opacity-80">
          Your one-stop shop for fun, safe, and affordable toy rentals.
          From learning games to action figures and baby toys — we make playtime smarter, cleaner, and more exciting for every child.
        </p>
        </div>


        <div className="flex gap-20 max-md:gap-10 max-sm:flex-col max-sm:gap-6">
          <nav aria-labelledby="legal-links">
            <h3 id="legal-links" className="mb-2 text-base font-semibold">Legal</h3>
            <ul className="flex flex-col gap-3">
              {legalLinks.map((link, index) => (
                <li key={index}>
                  <motion.button
                    onClick={() => handleLegalNavigation(link.route)}
                    className="text-sm cursor-pointer duration-[0.3s] ease-[ease] text-white text-opacity-80 transition-[color] hover:text-white focus:text-white focus:outline-none focus:underline"
                    whileHover={{ x: 5 }}
                  >
                    {link.text}
                  </motion.button>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-labelledby="contact-info">
            <h3 id="contact-info" className="mb-2 text-base font-semibold">Contact</h3>
            <ul className="flex flex-col gap-3">
              {contactInfo.map((contact, index) => (
                <li key={index}>
                  <motion.a
                    href={contact.href}
                    className="text-sm cursor-pointer duration-[0.3s] ease-[ease] text-white text-opacity-80 transition-[color] hover:text-white focus:text-white focus:outline-none focus:underline"
                    whileHover={{ x: 5 }}
                  >
                    {contact.text}
                  </motion.a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </motion.div>

      {/* Dividing line */}
      <div className="w-full h-px bg-white bg-opacity-20 my-8 max-w-[1400px] mx-auto"></div>

      {/* Copyright and Social Media */}
      <div className="flex justify-between items-center mx-auto my-0 max-w-[1400px] max-md:flex-col max-md:gap-4">
        <p className="text-xs text-white ">
  Designed & Developed by{" "}
  <a
    href="https://www.vikrin.com"      // ← replace with the actual website
    target="_blank"
    rel="noopener noreferrer"
    className="text-white cursor-pointer"
  >
    Vikrin
  </a><br></br>{" "}
  © 2024 Rentastic Toys. All Rights Reserved.
</p>

        <div className="flex gap-4">
          {socialLinks.map((social, index) => (
            <motion.a
              key={index}
              href={social.href}
              className="w-8 h-8 flex items-center justify-center text-white text-opacity-60 hover:text-white transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-sky-950 rounded"
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.9 }}
              aria-label={`Follow us on ${social.name}`}
            >
              {social.icon}
            </motion.a>
          ))}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
